import type { ReactNode } from "react";

/** 每个页面的开头：标题、一句说明（不超过 120 个字符，决策 D199）、右侧最多两个动作。 */
export function PageHeader({ title, description, actions }: { title: ReactNode; description?: ReactNode; actions?: ReactNode }) {
  return (
    <div className="ax-page-header">
      <div>
        <h1 className="ax-page-title">{title}</h1>
        {description && <p className="ax-page-desc">{description}</p>}
      </div>
      {actions && <div className="ax-page-actions">{actions}</div>}
    </div>
  );
}
